<template>
  <version-form
    :version="{gameId: selectedGameId}"
    mode="create"
    @submit="handleSubmit"
  />
</template>

<script>
  import VersionForm from '@/components/VersionForm'
  import { useCreateVersion } from '@/views/games/gameHooks'
  import { mapState } from 'vuex'

  export default {
    name: 'AddVersion',
    components: { VersionForm },
    mixins: [
      useCreateVersion('handleSubmit')
    ],
    computed: {
      ...mapState('game', ['selectedGameId']),
    },
  }
</script>

<style scoped>

</style>
